//抽奖PC WAP公用数据
import {$subscriber, ck} from "fire-wind-water";
import ws from "../services/webinar";

export function buildLotteryData(data) {
    return Object.assign(
        {
            luckyName: "",
            awardName: "",
            isShowLuckying: false,
            isShowLuckyList: false,
            isShowWinningList: false,
            isWinner: false,
            user: {},
            webinarInfo: {},
            luckyList: [],
            message: "",
            isShowResult: false,
            isDrawnPrize: false,
            luckyDrawDefImg: require("../assets/images/luckyDrow.jpg"),
            customFormId: '',
            drawMobile: '',
            drawName: '',
            drawAddress: '',
            isAction: false,
            isSubmitting: false,
            winnerList:[],
            luckyDrawId:"",
            resultId:'',
            webinarId: ''
        },
        data
    );
}

export function buildTableMethod(otherMethods) {
    return Object.assign(
        {
            close() {
                this.isShowLuckying = false;
                this.isShowLuckyList = false;
                this.isShowWinningList = false;
            },
            showLuckying() {
                this.isShowLuckyList = false;
                this.isShowWinningList = false;
                this.isShowLuckying = true;
            },
            showLuckyList() {
                this.isShowLuckying = false;
                this.isShowWinningList = false;
                this.isShowLuckyList = true;
            },
            encryptUserInfo(val, type) {
                var encryptor = {
                    email: function (val) {
                        var prefix = val.replace(/^(.*)@.*$/, "$1");
                        if (prefix.length < 5) {
                            return val.replace(/^[^@]*@(.*)$/, "****@$1");
                        }
                        return val.replace(/^(\w{2}).*(\w{2})@(.*)$/, "$1****$2@$3");
                    },
                    qq: function (val) {
                        if (val.length < 4) {
                            return val[0] + "****";
                        }
                        return val.replace(/^(\d{2})\d+(\d{2})$/, "$1****$2");
                    },
                    mobile: function (val) {
                        if (val.length !== 11) {
                            return val.replace(/^(.*)([\w]{4})$/, "****$2");
                        }
                        return val.replace(/^(\w{3})\w{4}(\w{4})$/, "$1****$2");
                    }
                };
                if (Object.prototype.hasOwnProperty.call(encryptor, type)) {
                    if (typeof val !== "string") {
                        return val;
                    }

                    return encryptor[type](val);
                }

                return val;
            },

            //获取显示名
            getShowName(userInfo, index) {
                let self = this;
                var infoList = ["mobile", "email", "qq", "nickName"];
                if (!index) {
                    index = 0;
                }
                var userName = userInfo["userName"] || userInfo["realName"] || "";
                if (!userName.length) {
                    userName = "匿名";
                }
                var info = infoList[index];
                if (userInfo[info]) {
                    return userName + " " + self.encryptUserInfo(userInfo[info], info);
                } else {
                    if (index < infoList.length) {
                        index++;
                        return self.getShowName(userInfo, index);
                    } else {
                        return userName;
                    }
                }
            },
            getLuckyDrawRoster(data,type) {
                this.webinarId=data.webinarId;
               const self=this;
               if(self.isShowResult){
                   return
               }
                let params = {
                    webinarId: data.webinarId,
                    globalUserId: ck.cookie("globalUserId")
                };
               const random=Math.random()
               setTimeout(()=>{
                   ws.getLotteryLuck(params).subscribe(data => {
                       self.luckyDrawId=data.content.lkid
                       ck.cookie('isDrawnPrize'+self.luckyDrawId, 'true');
                       if (Object.prototype.hasOwnProperty.call(data.content, 'items')) {
                           ///  中奖名单 没中奖
                           self.isWinner = false;
                           self.winnerList=data.content.items;
                       } else {
                           // 中奖了
                           self.isWinner = true;
                           self.resultId=data.content.resultId
                           if(ck.cookie('drawInfo'+self.webinarId)){
                               self.isAction=true
                           }
                           if (Object.prototype.hasOwnProperty.call(data.content, 'user')) {
                               if(data.content.user){
                                   const {userAddr,userMobile,userName} =data.content.user
                                   if(userAddr){
                                       self.drawAddress = userAddr
                                   }
                                   if(userMobile){
                                       self.drawMobile = userMobile
                                   }
                                   if(userName){
                                       self.drawName = userName
                                   }
                               }
                           }
                       }
                       if(type=='showResult'){
                           self.isShowResult = true;
                       }else {
                           self.isDrawnPrize = true;
                           setTimeout(()=>{
                               self.isDrawnPrize = false;
                           },3000)

                       }
                   });
               },random)
            },
            winnerListHandler(winnerList) {
                let self = this;
                for (let i in winnerList) {
                    let winner = winnerList[i];
                    winner.showName = self.getShowName(winner);
                    winner.name =
                        winner.name ||
                        self.encryptUserInfo(winner.mobile, "mobile") ||
                        self.encryptUserInfo(winner.email, "email");
                    if (winner.userid == self.user.applicantId) {
                        self.isWinner = true;
                    }
                }
                return winnerList;
            },
            actionDrawCustomForm() {
                let self = this;
                if (self.isAction || self.isSubmitting) {
                    return
                }
                if (!self.drawMobile || !self.drawName || !self.drawAddress) {
                    $subscriber.emit("showPopup", {message: "请填写完整中奖信息"});
                    return;
                }
                if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(self.drawMobile)) {
                    $subscriber.emit("showPopup", {message: "手机号格式不正确"});
                    this.showToast("手机格式不正确");
                    return;
                }
                let params = {
                    globalUserId:ck.cookie("globalUserId"),
                    luckyDrawId:self.luckyDrawId,
                    resultId:parseInt(self.resultId),
                    browseInfo: {},
                    postcode:'',
                    userAddr: self.drawAddress,
                userMobile: self.drawMobile,
                userName: self.drawName,
                }
                self.isSubmitting = true;
                ws.luckyDrawSaveUserInfo(params).subscribe((data) => {
                    if (data.result == 0) {
                        ck.cookie('drawInfo'+self.webinarId, {
                            drawMobile: self.drawMobile,
                            drawAddress: self.drawAddress,
                            drawName: self.drawName
                        });
                        self.isAction = true;
                        self.isSubmitting = false;
                        window.$sk.tips.show("提交成功");
                        self.isShowResult = false;
                    } else {
                        self.isSubmitting = false;
                        self.isAction = false;
                    }
                })
            },
            // 查看当前用户是否参与过本次抽奖
            getNumberOfDraws(data){
                let params = {
                    cookieId:ck.cookie("globalUserId"),
                    globalUserId:ck.cookie("globalUserId"),
                    luckyDrawId:data.luckyDrawId,
                    openId:"",
                    referenceUrl:"",
                    sess:"",
                    url:""
                }
                ws.getNumberOfDraws(params).subscribe((data) => {
                    if (data.result == 69645) {
                     /// 参与过抽奖
                        //TODO

                    }
                })
            }
        },
        otherMethods
    );
}

export function mounted(model) {
    let self = model;
    $subscriber.subscribe("webinarInfo", data => {
        self.webinarInfo = data;
        self.customFormId = data.customFieldObject && data.customFieldObject.drawCustomFormId || '';
    });
    $subscriber.subscribe("userInfo", data => {
        self.user = data;
        self.drawMobile = data.mobile || '';
    });
    $subscriber.subscribe("onLuckyDraw", data => {
        self.luckyImageUrl = data.data.image;
        self.luckyName = data.data.name;
        self.awardName = data.data.awardName;
        self.message = data.data.message;
        self.isShowLuckyList = false;
        self.isShowWinningList = false;

        // self.isShowLuckying = true;
    });
    $subscriber.subscribe("onLuckyDrawEnd", data => {
        self.isWinner = false;
        self.winnerList = data.data.members;
        self.luckyName = data.data.name;
        ck.cookie('currentRoster', data.data.awardDetailId);
        self.winnerListHandler(self.winnerList);
        //      for(let i in self.winnerList) {
        //        let winner = self.winnerList[i];
        //        winner.showName = self.getShowName(winner);
        //        winner.name = winner.name || self.encryptUserInfo(winner.mobile, 'mobile') || self.encryptUserInfo(winner.email, 'email');
        //        if(winner.userid == self.user.applicantId){
        //          self.isWinner  = true;
        //        }
        //      }
        // self.isShowLuckying = false;
        if (self.isWinner) {
            self.isShowResult = true;
        }
    });
    // $subscriber.subscribe("getLuckyDrawRoster", () => {
    //   self.getLuckyDrawRoster();
    // });

    $subscriber.subscribe("showResult", (data) => {
        self.getLuckyDrawRoster(data);
    });

    $subscriber.subscribe("onNotification", (data)=> {
        if(data.notification.content.indexOf('|&|')>-1){
            if(data.notification.content.indexOf('|&|showLuckyResult')>-1){
                const luckyDrawId= data.notification.content.split('|&|')[2]
                if(ck.cookie('isDrawnPrize'+luckyDrawId)=='true'){
                    self.isDrawnPrize = false;
                    self.getLuckyDrawRoster({
                        webinarId:self.webinarId
                    },'showResult')
                }
            }
        }
    })



}
